module.exports = __webpack_public_path__ + "img/osp_logo.936f9837.png";